/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spell_NumbersInputs */



/**
* | output |
* | --- |
* | "Spell #1...10" |
*
* @param {Spell_NumbersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spell_numbers = /** @type {((inputs?: Spell_NumbersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spell_NumbersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Épeler #1...10")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zauber #1...10")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incantesimo n. 1...10")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Заклинание №1...10")
	if (locale === "es") return /** @type {LocalizedString} */ ("Hechizo #1...10")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("咒语#1...10")
	if (locale === "ja") return /** @type {LocalizedString} */ ("呪文 #1...10")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मंत्र #1...10")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Feitiço nº 1...10")
	return /** @type {LocalizedString} */ ("Spell #1...10")
});